import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { SentryConfig } from './sentry-config.model';
import { SentryService } from './sentry.service';

export function provideSentry(config: SentryConfig): (Provider | EnvironmentProviders)[] {
  if (!(config.enabled && config.dsn)) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      const sentryService = inject(SentryService);

      sentryService.initialize(config);
    }),
    {
      deps: [Router],
      provide: Sentry.TraceService,
    },
  ];
}
